import ForSchools from './ForSchools';

export { ForSchools };
export default ForSchools;
